import React from 'react';
import DataMetrics from '../dataMetrics';
import { FiStar } from 'react-icons/fi';

const Rating = ({ rating, totalRatingCount }) => {
  return (
    <DataMetrics
      classes="text-center bg-gray"
    >
      <span>
        <FiStar fill={ rating >= 4 ? '#0cce6b' : rating >2 ? '#ffa400' : '#ff4e42'} color={ rating >= 4 ? '#0cce6b' : rating >2 ? '#ffa400' : '#ff4e42'} />
        { rating } 
        <small> / { totalRatingCount } Ratings</small> </span>
    </DataMetrics>
  )
}
export default Rating;